var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6844 2.11597C5.92424 2.11597 2.06091 5.97929 2.06091 10.7395C2.06091 15.4996 5.92424 19.363 10.6844 19.363C15.4446 19.363 19.3079 15.4996 19.3079 10.7395C19.3079 5.97929 15.4446 2.11597 10.6844 2.11597ZM6.76441 6.81987C7.14327 6.44101 7.75753 6.44101 8.1364 6.81987L10.6842 9.36769L13.232 6.81987C13.6109 6.44101 14.2252 6.44101 14.604 6.81987C14.9829 7.19874 14.9829 7.813 14.604 8.19186L12.0562 10.7397L14.604 13.2875C14.9829 13.6664 14.9829 14.2806 14.604 14.6595C14.2252 15.0383 13.6109 15.0383 13.232 14.6595L10.6842 12.1117L8.1364 14.6595C7.75753 15.0383 7.14327 15.0383 6.76441 14.6595C6.38555 14.2806 6.38555 13.6664 6.76441 13.2875L9.31223 10.7397L6.76441 8.19186C6.38555 7.813 6.38555 7.19874 6.76441 6.81987Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/xMark.ff556af6e62e112ab95303203607c90e.svg";
export { ForwardRef as ReactComponent };